export default () => '#009de1';